import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductInventory extends Component {
  #observer;
  #baseText = '';
  #request = 0;

  #syncAppStatus = () => {
    const state = this.querySelector('[data-stock-status]');
    const text = this.querySelector('.product-inventory__text');
    const icon = this.querySelector('.product-inventory__icon');
    if (!state || !text || !icon) return;
    const scope = this.closest('.shopify-section, dialog');
    const app = scope?.querySelector('.essential-preorder-container-active [data-essential-preorder-element="button"]');
    const pre = state.dataset.available === 'true' && app && app.getClientRects().length > 0;
    const label = pre ? state.dataset.preorderLabel : this.#baseText;
    if (text.textContent !== label) text.textContent = label;
    const status = pre ? 'preorder' : state.dataset.stockStatus;
    const className = `svg-wrapper product-inventory__icon product-inventory__icon-${status}`;
    if (icon.className !== className) icon.className = className;
  };

  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#baseText = this.querySelector('.product-inventory__text')?.textContent || '';
    this.#observer = new MutationObserver((records) => {
      if (records.some((record) => !this.contains(record.target))) this.#syncAppStatus();
    });
    if (closestSection) this.#observer.observe(closestSection, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    this.#syncAppStatus();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.#request++;
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event by updating the inventory.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const request = ++this.#request;
    event.promise
      .then(({ detail }) => {
        if (!this.isConnected || request !== this.#request || !detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newInventory = html.querySelector('product-inventory');
        if (!newInventory) return;

        morph(this, newInventory, { childrenOnly: true });
        this.#baseText = this.querySelector('.product-inventory__text')?.textContent || '';
        this.#syncAppStatus();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-inventory] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
